export default __webpack_public_path__ + "static/keyless-efda6b94d0378fe0915203d72403f0de.jpg";